<template>
    <div class="form-group_up">
        <label class="form-label" for="name-f">Пошук</label>
        <div class="input-group">
            <div class="input-group-prepend">
                <span class="input-group-text border-right-0">
                    <i class="fal fa-democrat"></i>
                </span>
            </div>
            
            <input type="text" v-model="search_txt" id="filter_search" class="form-control" placeholder="Пошук"/>
            
            <div class="input-group-append srch">
                <button class="btn btn-primary shadow-0 waves-effect waves-themed" @click="send_search">
                    <i class="fal fa-search"></i>
                </button>
                <button type="button" class="btn btn-outline-primary shadow-0 waves-effect waves-themed"
                        data-toggle="collapse"
                        data-target="#collapseFilter"
                        aria-controls="collapseFilter"
                        aria-expanded="true"
                >
                    Фільтр
                </button>
                <button type="button" class="btn btn-danger shadow-0 waves-effect waves-themed" @click="clear_form">
                    <span class="fal fa-times mr-1"></span>
                    Очистити
                </button>
            </div>
        </div>
        
        <div class="frame-wrap mt-3 mb-0 w-100">
            <div
                class="collapse"
                :class="{ show: !!localFilter.user_status || !!localFilter.company_edrpou}"
                id="collapseFilter" >
                <div class="card card-body row">
                    <div class="row">
                        
                        <v-select  v-model="localFilter.company_edrpou"
                                   @search="onSearch"
                                   @update:modelValue="search"
                                   placeholder="Контрагент"
                                   label="company"
                                   class="col-sm-6 mt-2"
                                   :reduce="owner => owner.edrpou"
                                   :filterable="false"
                                   :options="multi_users"
                        >
                            <template #no-options>
                                Починайте вводити назву контрагента або ЄДРПОУ
                            </template>
                            
                            <template #option="option">
                                <div class="d-center">
                                    {{ option.company }}
                                    <small>ЄДРПОУ ({{ option.edrpou }})</small>
                                </div>
                            </template>
                            
                            <template #selected-option="option">
                                  <span v-if="multi_users.length > 0 && option">
                                        {{ option.company }}
                                        <small>ЄДРПОУ ({{ option.edrpou }})</small>
                                  </span>
                                  <span v-else>
                                    ЄДРПОУ ({{ filter.company_edrpou }})
                                  </span>
                            </template>
                
                        </v-select>
                        
                        
                        <v-select
                            label="text"
                            :options="liststatus"
                            v-model="localFilter.user_status"
                            :reduce="status => status.value"
                            placeholder="Статус"
                            class="col-sm-6 mt-2"
                            @update:modelValue="search"
                        ></v-select>
                    </div>
                
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>

import vSelect from 'vue-select';
export default {
    name: "users_filter",
    emits: ["update:filter", "search_called", "clean_filter"],
    props: {
        searchValue: {
            type: String,
            default: ''
        },
        
        filter: {
            type: Object,
            default: () => ({
                user_status: "",
                company_edrpou: "",
            }),
        },
    },
    
    components:  {
        vSelect
    },
    
    data() {
        return {
            search_txt: this.searchValue,
            multi_users: [],
            liststatus: [
                { value: "new", text: "Нові" },
                { value: "notregistered", text: "Не завершена реєстрація" },
                { value: "verificated", text: "Затверджені" },
                { value: "block", text: "Видалені" },
                { value: "blacklist", text: "Чорний список" },
                { value: "subscription_deactivated", text: "Відключена розсилка" },
            ],
        };
    },
    
    methods: {
        
        search() {
            this.$emit("search_called", this.search_txt);
        },
        
        send_search() {
            this.$emit("search_called", this.search_txt);
        },
        
        clear_form() {
            this.search_txt = "";
            this.$emit("clean_filter");
        },
        
        onSearch(search, loading) {
            if (search.length > 2) {
                loading(true);
                this.search_user(loading, search);
            }
        },
        
        async search_user(loading, search) {
            try {
                const { data } = await axios.post("/internal/api/getUserFilterList", { search });
                loading(false);
                this.multi_users = data.status === "operation_success" ? data.data : [];
            } catch (e) {
                loading(false);
                this.multi_users = [];
            }
        },
    },
    
    computed: {
        localFilter: {
            get() {
                return this.filter;
            },
            set(v) {
                this.$emit("update:filter", v);
            },
        },
    },
    
};
</script>

<style scoped>
</style>
